import { ProfilePicAction } from '../profile/editor/ProfileEditorPage';
import { PaymentModel } from '../theSource/constants/PaymentModel';
import { PWYWPrice } from './theSource';

interface CognitoSession {
    idToken: {
        jwtToken: string;
    };
    refreshToken: {
        token: string;
    };
    accessToken: {
        jwtToken: string;
    };
}

export interface CognitoUser {
    session: CognitoSession;
    username: string;
    rawResponse: any;
}

export interface ArtistInfo {
    funFact?: string;
    musicId?: string;
    videoId?: string;
    stripeAccountId?: string;
    onboardingComplete: boolean;
    costTextResponseType?: number;
    costVideoResponseType?: number;
    applicationFee: number;
    paymentModel: PaymentModel;
    subscriptionSettings?: ArtistSubscriptionSettings;
    newSubscriptionPrice?: number;
    newSubscriptionLabel?: string;
    subscriptionIntent?: SubscriptionIntent;
    pwywPrice?: PWYWPrice;
}

export type SubscriptionIntent = 'put' | 'delete';

export enum SubscriptionStatus {
    SUBSCRIBED = 'SUBSCRIBED',
    CANCELED = 'CANCELED',
    FREE_TIER = 'FREE_TIER',
}

export type PriceId = string;

export interface ArtistSubscriptionSettings {
    productName?: string;
    activePriceId: PriceId;
    subscriptionPriceInfo: Record<PriceId, SubscriptionPriceInfo>;
}

export interface SubscriptionPriceInfo {
    price: number;
    createdAt: string;
}

export interface PaymentInfo {
    customerId: string;
    paymentMethodId?: string;
}

export function parseCognitoResponse(cognitoResponse: any) {
    return {
        session: cognitoResponse.signInUserSession,
        username: cognitoResponse.username,
        rawResponse: cognitoResponse,
    };
}

export interface ListUsersResponse {
    users: User[];
    lastEvaluatedKey?: string;
}

export interface GetBatchUsersResponse {
    users: UserSummary[];
}

export interface UserSummary {
    username: string;
    displayName: string;
    isArtist: boolean;
    subscriptionStatus: SubscriptionStatus;
    subscriptionOverride?: boolean;
    quote?: string;
}

export interface UserNotificationSettings {
    artistNotificationSettings?: ArtistNotificationSettings;
    emailNotificationSettings?: EmailNotificationSettings;
}

export interface ArtistNotificationSettings {
    enableNewRequestsEmail: boolean;
}

export interface EmailNotificationSettings {
    enableArtistGeneratedEmails: boolean;
    requestResponseEmail: boolean;
    communityPostCreatedEmail: boolean;
    communityPostCommentEmail: boolean;
    communityPostTagEmail: boolean;
    communityPostCommentTagEmail: boolean;
    exclusiveCommunityPostCreatedEmail: boolean;
    essTopicCreatedEmail: boolean;
    essArtistTopicCreatedEmail: boolean;
    essArtistThreadCreatedEmail: boolean;
    essThreadReplyEmail: boolean;
    forumsThreadTagEmail: boolean;
    weeklySiteActivityEmail: boolean;
}

export interface User {
    cognitoUser?: CognitoUser;
    username: string;
    email: string;
    displayName: string;
    bio: string;
    isAdmin: boolean;
    isArtist: boolean;
    createdAt: string;
    updatedAt: string;
    artistInfo?: ArtistInfo;
    hasCreatedProfile: boolean;
    hasProfilePicture: boolean;
    profilePicAction?: ProfilePicAction;
    paymentInfo?: PaymentInfo;
    userNotificationSettings: UserNotificationSettings;
    subscriptionStatus: SubscriptionStatus;
    subscriptionOverride?: boolean;
    quote?: string;
}

export function parseUser(apiResponse: any, cognitoUser?: CognitoUser) {
    return {
        ...apiResponse,
        cognitoUser,
    };
}

export function hasCreatedProfile(user: User): boolean {
    if (user.displayName.trim() === '' || !user.hasCreatedProfile) {
        return false;
    }
    return true;
}
